import {DialogTitle} from '@apps-common/ui-components';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import TourDialogImage from '@explorer/assets/images/tour-dialog-image.jsx';

const TourDialog = ({onTourSkip, onTourStart}) => {
  const {t} = useTranslation();

  return (
    <Dialog open>
      <DialogTitle title="Welcome to Explorer!" onClose={onTourSkip}>
        Welcome to Explorer!
      </DialogTitle>

      <DialogContent
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          textAlign: 'center',
        }}
      >
        <Box sx={{marginBlock: 1}}>
          <TourDialogImage />
        </Box>

        <Typography variant="body1" sx={{paddingInline: 4}}>
          Explorer is where you can preview Earth data for your AOIs across time
          to then be delivered to your collections.
        </Typography>
      </DialogContent>

      <DialogActions sx={{justifyContent: 'center', paddingBottom: 4}}>
        <Button color="primary" onClick={onTourSkip} data-qe="skip-tour-button">
          {t('tourDialog.skipButton', 'Skip')}
        </Button>

        <Button
          color="primary"
          onClick={onTourStart}
          data-qe="start-tour-button"
          variant="contained"
        >
          Start the tour
        </Button>
      </DialogActions>
    </Dialog>
  );
};

TourDialog.propTypes = {
  onTourSkip: PropTypes.func.isRequired,
  onTourStart: PropTypes.func.isRequired,
};

export default TourDialog;
